import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink } from 'react-router-dom';
import BookTableForm from './Bookform';

const Navbar = () => {
  const [showNavbar, setShowNavbar] = useState(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const lastScrollY = useRef(0);
  const [isFormVisible, setIsFormVisible] = useState(false);

  const toggleFormVisibility = () => {
    setIsFormVisible(!isFormVisible);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY.current) {
        setShowNavbar(false);
      } else {
        setShowNavbar(true);
      }
      lastScrollY.current = window.scrollY;
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const navbarStyle = {
    backgroundColor: '#000',
    transition: 'top 0.3s ease',
    position: 'fixed',
    top: showNavbar ? '0' : '-100px',
    zIndex: 1050,
    width: '100%',
    borderBottom: '1px solid #333',
  };

  const navLinkStyle = {
    color: '#fff',
    fontWeight: 'bold',
    textDecoration: 'none',
  };

  const activeNavLinkStyle = {
    color: '#af1831',
  };

  return (
    <>
      <div style={navbarStyle}>
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-dark">
            <div className="container-fluid">
              <Link to="/" className="navbar-brand d-flex align-items-center">
                <img
                  src="logo_1-01.png"
                  alt="The Momo Cafe Asian Tasty Food"
                  className="img-fluid me-2"
                  style={{ height: '60px', transition: 'height 0.3s ease', filter: 'brightness(100%) ' }}
                />
              </Link>

              <button
                className="navbar-toggler"
                type="button"
                onClick={toggleMobileMenu}
                aria-expanded={isMobileMenuOpen}
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>

              <div 
                className={`collapse navbar-collapse ${isMobileMenuOpen ? 'show' : ''}`}
                id="navbarCollapse"
              >
                <div className="navbar-nav mx-auto">
                  <NavLink
                    to="/"
                    className="nav-item nav-link text-center"
                    style={({ isActive }) => isActive ? { ...navLinkStyle, ...activeNavLinkStyle } : navLinkStyle}
                    onClick={closeMobileMenu}
                  >
                    Home
                  </NavLink>
                  <NavLink
                    to="/about"
                    className="nav-item nav-link text-center"
                    style={({ isActive }) => isActive ? { ...navLinkStyle, ...activeNavLinkStyle } : navLinkStyle}
                    onClick={closeMobileMenu}
                  >
                    About
                  </NavLink>
                  <NavLink
                    to="/menu"
                    className="nav-item nav-link text-center"
                    style={({ isActive }) => isActive ? { ...navLinkStyle, ...activeNavLinkStyle } : navLinkStyle}
                    onClick={closeMobileMenu}
                  >
                    Menu
                  </NavLink>
                  <NavLink
                    to="/contact"
                    className="nav-item nav-link text-center"
                    style={({ isActive }) => isActive ? { ...navLinkStyle, ...activeNavLinkStyle } : navLinkStyle}
                    onClick={closeMobileMenu}
                  >
                    Contact
                  </NavLink>
                </div>
                <div className="navbar-nav text-center">
                  <button 
                    className="btn btn-danger"
                    onClick={() => {
                      toggleFormVisibility();
                      closeMobileMenu();
                    }}
                   
                    style={{ 
                      backgroundColor: '#af1831', 
                      borderColor: '#af1831',
                      color: '#fff'
                    }}
                  >
                    Book Table
                  </button>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>

      {/* Popup */}
      {isFormVisible && (
        <div className="popup-overlay" onClick={toggleFormVisibility}>
          <div
            className="popup-form-container"
            onClick={(e) => e.stopPropagation()}
          >
            <BookTableForm />
            <button
              className="close-button"
               onClick={toggleFormVisibility}
                  >
                  &times;
               </button>
          </div>
        </div>
      )}

      <style jsx>{`
        .popup-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }

        .popup-form-container {
          width: flex;
          background: white;
          padding: 20px;
          border-radius: 10px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
          position: relative;
        }

      
              .close-button {
              position: absolute;
              top: 10px;
              right: 10px;
              background: transparent;
              border: none;
              font-size: 2rem;
              cursor: pointer;
              color: #af1831;
              transition: color 0.3s ease;
             }

             .close-button:hover {
               color: #95152b; /* Darker shade on hover */
         }
      `}</style>
    </>
  );
};

export default Navbar;
